/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class CSVSurveyDataApi extends BaseApi {
  endPoint: string = '/api/admin/csv-survey-data';
}
